import { userConstants } from 'Constants';
import Request from 'Services/request.js';
import { history } from 'Helpers/history';
import { toast as toastr } from 'react-toastify';
import { profileActions } from 'Actions';
import { handleApiError, clearStorage, encryptAndSaveToLocalStorage, decryptDataFromLocalStorage } from 'Helpers/index';
import { apiHost, apiUrl } from 'Helpers/apiurl';
import routesPath from 'Constants/routes.constants';

export const userActions = {
  login,
  logout,
  forgotPassword,
  changePassword,
  resetPassword,
  activateaccount
};

function login(username, password) {
  return (dispatch) => {
    dispatch(request({}));

    Request.create('/login', {
      username,
      password
    })
      .then((response) => {
        const { data } = response;
        encryptAndSaveToLocalStorage('user', data.token);
        encryptAndSaveToLocalStorage('userdetail', JSON.stringify({ username, password }));
        dispatch(success(data));
        dispatch(profileActions.fetchProfile('login'));
        history.push(history.location.state?.from?.pathname || routesPath.root);
      })
      .catch((error) => {
        Request.handleCatchedErrors(error || 'Error', dispatch, failure )
      });
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user }; }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user }; }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
}

function activateaccount(activatePasswordObject) {
  const Url = '/activateaccount'.concat('?',Request.objectToQueryString(activatePasswordObject))
  return (dispatch) => {
    dispatch(request({}));
    Request.get(Url,{})
      .then((response) => {
        const { data, message } = response;
        localStorage.removeItem('userdetail')
        dispatch(success(data));
        toastr.success(message);
        history.push('/login');
      })
      .catch((error) => {
        dispatch(failure(error.toString()));
      });
  };

  function request(response) { return { type: userConstants.ACTIVATE_PASSWORD_REQUEST, response }; }
  function success(response) { return { type: userConstants.ACTIVATE_PASSWORD_SUCCESS, response }; }
  function failure(error) { return { type: userConstants.ACTIVATE_PASSWORD_FAILURE, error }; }
}

function forgotPassword(emailId) {
  return (dispatch) => {
    dispatch(request({}));

    //fetch(apiUrl, options)
    Request.create('/forgotpassword', {
      emailId
    })
      .then((response) => {
        const { data } = response;
        clearStorage();
        dispatch(success(data));
      })
      .catch((error) => {
        dispatch(failure(error.toString()));
      });
  };

  function request(response) { return { type: userConstants.FORGET_PASSWORD_REQUEST, response }; }
  function success(response) { return { type: userConstants.FORGET_PASSWORD_SUCCESS, response }; }
  function failure(error) { return { type: userConstants.FORGET_PASSWORD_FAILURE, error }; }
}

function changePassword(currentPassword, newPassword, confirmPassword) {
  const { username } = JSON.parse(
		decryptDataFromLocalStorage('userdetail') || '{}'
	);
  return (dispatch) => {
    dispatch(request({}));
    Request.create('/admin/changepassword', {
      currentPassword,
      newPassword,
      confirmPassword
    })
      .then((response) => {
        const { data, message } = response;
        dispatch(success(data));
        encryptAndSaveToLocalStorage(
          'userdetail',
          JSON.stringify({ username, password: newPassword })
        );
        dispatch(login(username, newPassword));
        return message
      }).then(message => {
        toastr.dismiss();
        toastr.success(message)
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failure(error.toString()));
        }
      });
  };

  function request(response) { return { type: userConstants.CHANGE_PASSWORD_REQUEST, response }; }
  function success(response) { return { type: userConstants.CHANGE_PASSWORD_SUCCESS, response }; }
  function failure(error) { return { type: userConstants.CHANGE_PASSWORD_FAILURE, error }; }
}

function resetPassword(resetPasswordObject) {
  const Url = '/resetpassword'.concat('?',Request.objectToQueryString(resetPasswordObject))
  return (dispatch) => {
    dispatch(request({}));
    Request.get(Url,{})
      .then((response) => {
        const { data } = response;
        dispatch(success(data));
        localStorage.removeItem('userdetail');
        toastr.dismiss();
        toastr.success('Password reset is successful');
        history.push('/login');
      })
      .catch((error) => {
        dispatch(failure());
        toastr.dismiss();
        toastr.error(error.toString());
      });
  };

  function request(response) { return { type: userConstants.RESET_PASSWORD_REQUEST, response }; }
  function success(response) { return { type: userConstants.RESET_PASSWORD_SUCCESS, response }; }
  function failure(error) { return { type: userConstants.RESET_PASSWORD_FAILURE, error }; }
}

function logoutPromise(params) {
   return Promise.resolve(true)
}

function logout(autoLogout = false) {
  return (dispatch) => {
    logoutPromise()
      .then(() => {
        dispatch(success());
        clearStorage();
        history.push(routesPath.root);
      })
  };
  function success(response) { return { type: userConstants.LOGOUT_SUCCESS, response, autoLogout }; }
}